




































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import SMSRechargePO from "@/store/entities/messageinfo/smsrechargelistpo";
import TreeSelect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import QRCode from "qrcodejs2";

@Component({
  components: { TreeSelect },
})
export default class SMSRecharge extends AbpBase {
  smsrechargepo: SMSRechargePO = new SMSRechargePO();
  treedata: [] = [];
  loading: boolean = false;
  async created() {
    await this.getSMSPackage();
    await this.getOrganizations();
    this.getItemDetail();
  }
  //保存
  save() {
    (this.$refs.queryForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true;
        let res = this.$store
          .dispatch({
            type: "smsrechargelist/create",
            data: this.smsrechargepo,
          })
          .then((value) => {
            this.$store.commit("app/closePage", "smsrecharge");
            this.$store.commit("app/removeTag", "smsrecharge");
            this.$router.push({
              name: "paysmsorder",
              params: { value },
            });
            this.loading = false;
          })
          .catch((err) => {
            console.log(err);
            this.loading = false;
          });
        this.loading = false;
      }
    });
  }
  itemRule = {
    organizationId: [
      {
        required: true,
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    smsPackageId: [
      {
        required: true,
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    rechargePrice: [
      {
        required: true,
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    rechargeNum: [
      {
        required: true,
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    rechargeAmmount: [
      {
        required: true,
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    payTypeId: [
      {
        required: true,
        type: "number",
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
  };
  //获取组织
  async getOrganizations() {
    await this.$store
      .dispatch("organization/getCommanySelectTree")
      .then((val) => {
        this.$data.organizations = val;
      })
      .catch((err) => {
        console.log(err);
      });
  }
  //改变数量
  changRechargeNum() {
    this.smsrechargepo.rechargeNum = parseInt(
      this.smsrechargepo.rechargeNum.toFixed(0)
    );
    (this.smsrechargepo as any) = {
      tenantId: this.smsrechargepo.tenantId,
      smsPackageId: this.smsrechargepo.smsPackageId,
      organizationId: this.smsrechargepo.organizationId,
      rechargeTime: this.smsrechargepo.rechargeTime,
      rechargeNum: this.smsrechargepo.rechargeNum,
      rechargePrice: this.smsrechargepo.rechargePrice,
      beforNum: this.smsrechargepo.beforNum,
      endNum: this.smsrechargepo.endNum,
      packageNum: this.smsrechargepo.packageNum,
      rechargeTotalNum:
        this.smsrechargepo.packageNum * this.smsrechargepo.rechargeNum,
      rechargeAmmount:
        this.smsrechargepo.rechargeNum * this.smsrechargepo.rechargePrice,
      //rechargeAmmount: 0.01,
    };
  }
  //选择不同充值包
  changeSMSPackage(val) {
    this.smsrechargepo.smsPackageId = val;
    let smsp = this.$data.smspackage.filter((ele) => {
      return ele.id == val;
    });
    //console.log(smsp);
    this.smsrechargepo.rechargePrice =
      smsp.length > 0 ? smsp[0].totalAmmount : 0;
    this.smsrechargepo.packageNum = smsp.length > 0 ? smsp[0].num : 0;
    this.smsrechargepo.rechargeTotalNum =
      this.smsrechargepo.packageNum * this.smsrechargepo.rechargeNum;
    (this.smsrechargepo as any) = {
      tenantId: this.smsrechargepo.tenantId,
      smsPackageId: this.smsrechargepo.smsPackageId,
      organizationId: this.smsrechargepo.organizationId,
      rechargeTime: this.smsrechargepo.rechargeTime,
      rechargeNum: this.smsrechargepo.rechargeNum,
      rechargePrice: this.smsrechargepo.rechargePrice,
      beforNum: this.smsrechargepo.beforNum,
      endNum: this.smsrechargepo.endNum,
      packageNum: this.smsrechargepo.packageNum,
      rechargeTotalNum: this.smsrechargepo.rechargeTotalNum,
      rechargeAmmount: this.smsrechargepo.rechargeNum * this.smsrechargepo.rechargePrice,
      //rechargeAmmount: 0.01,
    };
  }
  //获取充值包
  async getSMSPackage() {
    let res = await this.$store
      .dispatch("smspackage/getAllSMSPackage")
      .then((val) => {
        if (val.length > 0) {
          this.$data.smspackage = val;
          this.smsrechargepo.smsPackageId = val[0].id;
          this.smsrechargepo.rechargePrice = val[0].totalAmmount;
          this.smsrechargepo.rechargeNum = 1;
          this.smsrechargepo.rechargeAmmount =
            this.smsrechargepo.rechargePrice * this.smsrechargepo.rechargeNum;
          //this.smsrechargepo.rechargeAmmount = 0.01;
          (this.smsrechargepo.packageNum = val[0].num),
            (this.smsrechargepo.rechargeTotalNum =
              this.smsrechargepo.packageNum * this.smsrechargepo.rechargeNum);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  //支付方式
  getItemDetail() {
    if (localStorage.getItem("itemdetail") === null) {
      this.$store.dispatch({
        type: "itemdetail/getdetailtolocalstorge",
      });
    }
    let detaillist = JSON.parse(localStorage.getItem("itemdetail"));
    if (detaillist.length > 0) {
      let pay = detaillist.filter((p) => {
        return p.itemId == 2;
      });
      pay.forEach((ele) => {
        if (ele.id == 6 || ele.id == 43) {
          this.$data.paymentType.push({ label: ele.name, value: ele.id });
        }
      });
    }
  }
  data() {
    return {
      smspackage: [], //短信包套餐
      paymentType: [], //支付方式
      organizations: [], //组织
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
}
